import { Injectable, } from '@angular/core';
import { IImagesRepo, } from '../repository/interfaces/iimages.repo';
import { UrlPath, } from '../services/UrlPath';
import { SocratesImage, } from '@socrates/common';

@Injectable()
export class ImagesService {
	constructor(
		private readonly imagesRepo: IImagesRepo,
		private readonly urlPath: UrlPath,
	) {
	}

	get profileImageUrl(): string {
		return this.urlPath.getImageServicePath('users/profile');
	}

	pullRootImage(imagePath: string): Promise<SocratesImage> {
		return this.imagesRepo.pullRootImage(imagePath);
	}

	pullUserImage(imageType: string): Promise<SocratesImage> {
		return this.imagesRepo.pullImage(`users/${ imageType }`, false);
	}

	pullOrganizationImage(imageType: string): Promise<SocratesImage> {
		return this.imagesRepo.pullImage(`org/images/${ imageType }`, false);
	}

	saveUserImage(imageType: string, image: SocratesImage): Promise<SocratesImage> {
		return this.imagesRepo.postImage(`users/${ imageType }`, image);
	}

	saveOrganizationImage(imageType: string, image: SocratesImage): Promise<SocratesImage> {
		return this.imagesRepo.postImage(`org/images/${ imageType }`, image);
	}

	tunnelImage(imageUrl: string): Promise<SocratesImage> {
		return this.imagesRepo.tunnelImage(imageUrl);
	}
}

